import {lazy, Suspense} from "react";
import CircularLoader from "../../customs/loader/main";


const Main = lazy(() => import("../../components/members/individuals/main"));


const Individuals = () => {

    return(
        <Suspense fallback={<CircularLoader/>}>
            <Main/>
        </Suspense>    
    )
};

export default Individuals;